import React from 'react';
import { Link } from 'react-router-dom';

import { Table } from 'semantic-ui-react';
import { Contexto } from 'src/contexto';
import { puedeVerFichaDeAlumno } from 'src/modulos/Alumnos';
import { NombrePersonal, NombrePersonalProps } from '../NombrePersonal';

export type LinkAlumnoProps = {
    readonly numeroDeContrato: number;
    readonly nombre: NombrePersonalProps['nombre'] | NombrePersonalProps;
    readonly paraTabla?: boolean;
};

export const LinkAlumno = (props: LinkAlumnoProps) => {
    const { numeroDeContrato, paraTabla } = props;
    const { nombre, patron } =
        'primerNombre' in props.nombre ? { nombre: props.nombre, patron: undefined } : props.nombre;

    const nombrePersonal = <NombrePersonal nombre={nombre} patron={patron} />;
    const linkAAlumno = (
        <Link to={`/alumnos/${numeroDeContrato}`}>
            <b>{nombrePersonal}</b>
        </Link>
    );

    return (
        <Contexto.Consumer>
            {({ usuarioActual }) =>
                puedeVerFichaDeAlumno(usuarioActual) ? (
                    paraTabla ? (
                        <Table.Cell selectable>{linkAAlumno}</Table.Cell>
                    ) : (
                        linkAAlumno
                    )
                ) : paraTabla ? (
                    <Table.Cell>{nombrePersonal}</Table.Cell>
                ) : (
                    nombrePersonal
                )
            }
        </Contexto.Consumer>
    );
};



// WEBPACK FOOTER //
// ./src/componentes/LinkAlumno/index.tsx